export default __webpack_public_path__ + "static/media/qdegreesLogo.fc5bc9c1.png";